export default function shouldDisableSaveButton(currentSubcategory) {
    return currentSubcategory.options
        .filter(function (option) { return option.fullOptionFormSettings.isDirty(); })
        .reduce(function (state, option) {
        return state &&
            !!option.fullOptionFormSettings.disableSave &&
            option.fullOptionFormSettings.disableSave();
    }, true);
}
//# sourceMappingURL=shouldDisableSaveButton.js.map